import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./components/Home/Home";
import About from "./components/pages/About/About.jsx";
import Contact from "./components/pages/ContactUs/Contact.jsx";
import ProtectedRoute from "./components/Utils/ProtectedRoute";
import { PatientDashboard } from "./components/Patient Dashboard/PatientDashboard";
import { Profile } from "./components/Profile/Profile";
import { BookingsPage } from "./components/BookingPage/BookingsPage";
import { FamilyMembers } from "./components/FamilyMembers/FamilyMembers";
import { NotFound } from "./components/Notfound/NotFound";
import ScrollToTop from "./components/ScrollToTop";
import { FriendlyUrlComponent } from "./components/pages/FriendlyUrlComponent/FriendlyUrlComponent";
import BlogComponent from "./components/pages/BlogComponent/BlogComponent.jsx";
import CanonicalManager from "./components/CanonicalComponent/CanonicalManager.jsx";
import "./App.css";
import BookingEdit from "./components/BookingPage/BookingEdit.js";
import {
  LocationProvider,
  useLocationContext,
} from "./context/LocationContext";
import AddressModalContainer from "./components/FormparserNew/AddressModalContainer.js";
import Privacypolicy from "./components/Footer/Privacypolicy.jsx";
import Termsandconditions from "./components/Footer/termsandconditions.jsx";
import AccountDeletionPolicy from "./components/Footer/AccountDeletionpolicy.jsx";
function LocationPermissionPopup() {
  const { detectLocation } = useLocationContext();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const asked = localStorage.getItem("location_permission_asked");
    if (!asked) {
      setShow(true);
    }
  }, []);

  if (!show) return null;

  return (
    <div className="location-cookie-popup">
      <div className="location-cookie-box">
        <h3>Allow Location Access?</h3>
        <p>We use your location to show nearby services.</p>

        <div className="location-cookie-actions">
          <button
            className="btn-allow"
            onClick={() => {
              detectLocation();
              localStorage.setItem("location_permission_asked", "true");
              setShow(false);
            }}
          >
            Allow
          </button>

          <button
            className="btn-deny"
            onClick={() => {
              localStorage.setItem("location_permission_asked", "true");
              setShow(false);
            }}
          >
            Not Now
          </button>
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <LocationProvider>
      <BrowserRouter>
        <CanonicalManager />
        <ScrollToTop />
        <LocationPermissionPopup />
        <AddressModalContainer />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<BlogComponent />} />
          <Route path="/privacy-policy" element={<Privacypolicy />} />
          <Route path="/terms-and-conditions" element={<Termsandconditions />} />
          <Route path="/account-deletion-policy" element={<AccountDeletionPolicy />} />
          <Route path="/:seo_url" element={<FriendlyUrlComponent />} />

          {/* <Route path="" element={<ProtectedRoute />}> */}
          <Route path="/patient-dashboard" element={<PatientDashboard />}>
            <Route path="/patient-dashboard/profile" element={<Profile />} />
            <Route
              path="/patient-dashboard/bookings"
              element={<BookingsPage />}
            />
            <Route
              path="/patient-dashboard/bookings/:id"
              element={<BookingEdit />}
            />
            <Route
              path="/patient-dashboard/family-members"
              element={<FamilyMembers />}
            />
          </Route>
          {/* </Route> */}

          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </LocationProvider>
  );
}

export default App;
